<template>
    <div class="h-8 lg:h-12 w-full relative my-8">
        <div class="absolute top-1/2 left-0 right-0 bg-gray-300 h-1" style="transform: translate(0, -50%)"></div>
        <div class="absolute top-1/2 left-0 right-0 bg-blue h-1 transition-all ease-in-out duration-200" :style="{ transform: 'translate(0, -50%)', width: progress + '%' }"></div>

        <div class="flex flex-row justify-between items-center w-full">
            <button
                @click="changeTab(tab)"
                v-for="(tab, index) in tabs"
                :class="[
                    'h-8 lg:h-12 w-8 lg:w-12 rounded-full flex items-center justify-center font-semibold lg:text-lg relative',
                    isTabActive(tab) ? ' bg-blue text-white' : ' bg-gray-300 text-white',
                    isTabClickable(tab) ? ' cursor-pointer' : ' cursor-default'
                ]"
            >
                <div v-if="tabs.indexOf(currentTab) > tabs.indexOf(tab)">
                    <svg class="w-4 lg:w-6" viewBox="0 0 30 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M29 1.00001C28.4471 0.388216 27.5 0.5 27 0.999972L8.58984 19.1781L2.45862 11.8226C1.92883 11.1874 1.0331 11.1462 0.457059 11.7313C-0.118537 12.3165 -0.155388 13.3064 0.374401 13.9422L7.50428 22.4952C7.76539 22.8086 8.13082 22.9907 8.51614 22.9995C8.52649 23 8.53647 23 8.54638 23C8.92084 23 9.28106 22.8357 9.54643 22.5436L29 3C29.5543 2.38983 29.5525 1.61179 29 1.00001Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <p v-else>
                    {{ index + 1 }}
                </p>

                <div class="absolute -bottom-6 lg:-bottom-8">
                    <small :class="['text-xxxs whitespace-nowrap', isTabActive(tab) ? 'text-blue' : 'text-gray-300', isLastActiveTab(tab) ? 'block' : 'hidden md:block']">
                        {{ $t(tabName(index, tab)) }}
                    </small>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        progress: 0
    }),
    props: {
        currentTab: String,
        tabs: Array,
        tabNamesPhraseKeys: Array
    },
    watch: {
        currentTab() {
            this.progress = (this.tabs.indexOf(this.currentTab) / (this.tabs.length - 1)) * 100;
        }
    },
    methods: {
        isTabClickable(tab) {
            if (this.tabs.indexOf(this.currentTab) <= this.tabs.indexOf(tab)) {
                return false;
            }

            if (tab === 'CheckoutLogin' || tab === 'CheckoutSuccess') {
                return false;
            }

            return true;
        },
        changeTab(tab) {
            if (this.tabs.indexOf(this.currentTab) < this.tabs.indexOf(tab)) {
                return;
            }

            if (tab === 'CheckoutLogin' || tab === 'CheckoutSuccess') {
                return;
            }

            this.$emit('changeTab', tab);
        },
        isTabActive(tab) {
            if (this.currentTab === 'CheckoutRegister' && tab === 'CheckoutLogin') {
                return true;
            }

            return this.tabs.indexOf(this.currentTab) >= this.tabs.indexOf(tab);
        },
        tabName(index, tab) {
            if (this.currentTab === 'CheckoutRegister' && tab === 'CheckoutLogin') {
                return 'plain_register';
            }

            return this.tabNamesPhraseKeys[index];
        },
        isLastActiveTab(tab) {
            return this.tabs.indexOf(this.currentTab) === this.tabs.indexOf(tab);
        }
    },
    emits: ['changeTab']
};
</script>
